'use client';

import { useTranslations } from '@scatterlab/zeta-core';
import { Button, Warning24Icon } from '@scatterlab/zeta-ui';
import { FC, memo, use, useCallback, useLayoutEffect } from 'react';

import { HandledErrorMessage } from '@scatterlab/zeta-service/constants/common';
import { ErrorSetterContext } from '@scatterlab/zeta-service/contexts/ErrorContext';

type ErrorAreaProps = {
  message?: HandledErrorMessage;
  reset?: () => void;
};

const ErrorArea: FC<ErrorAreaProps> = ({ message, reset }) => {
  const t = useTranslations('에러_화면');

  const setError = use(ErrorSetterContext);

  useLayoutEffect(() => {
    setError(true);
    return () => {
      setError(false);
    };
  }, [setError]);

  const redirectToHome = useCallback(() => {
    window.location.href = '/';
  }, []);

  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-1">
      <Warning24Icon className="size-[58px] text-primary-400" />
      <h1 className="title24 pt-2">
        {t(`에러_메시지.${message ?? 'DEFAULT'}.Title`)}
      </h1>
      <div className="body14 mb-2 text-white/50">
        {t(`에러_메시지.${message ?? 'DEFAULT'}.Body`)}
      </div>
      <Button
        type="button"
        className="w-[120px]"
        variant="secondary"
        onPress={() => {
          reset?.();
          redirectToHome();
        }}
      >
        {t('확인')}
      </Button>
    </div>
  );
};

export default memo(ErrorArea);
